export const css = {
	oneaction: '_3lUH3Efq',
	' _key': 'afcpe-theme/afcpe/quiz-widgets/discussion'
};

export default css;
